import type { PartnerInvoice, PaymentsOpsTransaction } from 'src/interfaces/transactionsReview'
import type { State } from '../reducers/types'

export const getIncomingTransactions = (state: State): PaymentsOpsTransaction[] => {
  return state.transactionsReview.incoming
}

export const getIncomingTransactionsTotal = (state: State): number => {
  return state.transactionsReview.incomingTotal
}

export const getIncomingTransactionsLoading = (state: State): boolean => {
  return state.transactionsReview.incomingLoading
}

export const getIncomingTransactionsError = (state: State): string | null => {
  return state.transactionsReview.incomingError
}

export const getOutgoingTransactions = (state: State): PaymentsOpsTransaction[] => {
  return state.transactionsReview.outgoing
}

export const getOutgoingTransactionsLoading = (state: State): boolean => {
  return state.transactionsReview.outgoingLoading
}

export const getOutgoingTransactionsError = (state: State): string | null => {
  return state.transactionsReview.outgoingError
}

export const getPartnerPendingInvoices = (state: State): PartnerInvoice[] => {
  return state.transactionsReview.pendingInvoices
}

export const getPartnerPendingInvoicesPartnerId = (state: State): string | null => {
  return state.transactionsReview.pendingInvoicesPartnerId
}

export const getPartnerPendingInvoicesLoading = (state: State): boolean => {
  return state.transactionsReview.pendingInvoicesLoading
}

export const getPartnerPendingInvoicesError = (state: State): string | null => {
  return state.transactionsReview.pendingInvoicesError
}

export const getTransactionsReviewSubmitting = (state: State): boolean => {
  return state.transactionsReview.submitting
}
